import { NgModule } from '@angular/core';
import { AbcTextAreaComponent } from './abcTextArea.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    declarations: [AbcTextAreaComponent],
    exports: [AbcTextAreaComponent]
})
export class AbcTextAreaModule {
  constructor() {}
}
